import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth';

/**
 * Hook para manejar la lógica de mostrar la página de configuración de pagos
 * Se ejecuta una sola vez después del login/registro
 */
export const usePaymentSetupFlow = () => {
  const { isLoggedIn, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [shouldShowPaymentSetup, setShouldShowPaymentSetup] = useState(false);

  useEffect(() => {
    // Solo verificar si el usuario está logueado y tenemos datos de usuario
    if (!isLoggedIn || !user) {
      return;
    }

    // No mostrar en ciertas páginas
    const excludedPaths = [
      '/payment-setup',
      '/login', 
      '/register',
      '/company-setup',
      '/email-validation'
    ];
    
    if (excludedPaths.some(path => location.pathname.includes(path))) {
      return;
    }

    // Verificar si ya se mostró la configuración de pagos
    const paymentSetupSeen = localStorage.getItem('payment_setup_seen');
    const userKey = `payment_setup_seen_${user.id}`;
    const userSpecificSeen = localStorage.getItem(userKey);

    console.log('🔍 Payment Setup Flow Check:', {
      userId: user.id,
      currentPath: location.pathname,
      paymentSetupSeen,
      userSpecificSeen,
      isLoggedIn
    });

    // Si nunca se mostró para este usuario específico, mostrar la página
    if (!userSpecificSeen && !paymentSetupSeen) {
      console.log('🎯 Mostrando configuración de pagos por primera vez para el usuario');
      setShouldShowPaymentSetup(true);
      
      // Pequeño delay para asegurar que la UI esté estable
      setTimeout(() => {
        navigate('/payment-setup', { 
          state: { 
            fromAutoFlow: true,
            redirectTo: location.pathname 
          } 
        });
      }, 500);
    }
  }, [isLoggedIn, user, location.pathname, navigate]);

  const markPaymentSetupAsSeen = () => {
    if (user?.id) {
      const userKey = `payment_setup_seen_${user.id}`;
      localStorage.setItem(userKey, 'true');
      localStorage.setItem('payment_setup_seen', 'true');
    }
    setShouldShowPaymentSetup(false);
  };

  return {
    shouldShowPaymentSetup,
    markPaymentSetupAsSeen,
  };
};
